import { render, staticRenderFns } from "./SmsHistoryTable.vue?vue&type=template&id=14d4381a&scoped=true&"
import script from "./SmsHistoryTable.vue?vue&type=script&lang=js&"
export * from "./SmsHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./SmsHistoryTable.vue?vue&type=style&index=0&id=14d4381a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d4381a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VIcon,VSimpleTable})
